var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBonus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.19 21.985h-7.284c-.55 0-.922.46-.922.921v21.531c0 .558.461.922.922.922h7.283c.461 0 .922-.373.922-.922V22.906c0-.55-.461-.921-.922-.921Zm-.922 21.53h-5.44V23.837h5.44v19.68Z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.799 25.13H2.515c-.55 0-.921.46-.921.92v18.395c0 .558.46.922.921.922H9.8c.46 0 .921-.373.921-.922V26.051a.92.92 0 0 0-.921-.922Zm-.922 18.385h-5.44V26.972h5.44v16.543Z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.843 14.959 35.716 2.297c-.372-.46-1.107-.46-1.47 0l-9.127 12.662c-.372.523-.23 1.382.736 1.382h4.518v28.097c0 .558.461.921.922.921h7.283c.46 0 .922-.372 1.01-.921V16.35h4.52c.903 0 1.098-.922.735-1.391Zm-6.274-.461c-.549 0-.921.46-.921.921v28.097h-5.53V15.42a.92.92 0 0 0-.92-.922H27.51l7.372-10.163 7.372 10.163H38.57Z",
    fill: "url(#d)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 20.547,
    y1: 21.985,
    x2: 20.547,
    y2: 45.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 6.157,
    y1: 25.129,
    x2: 6.157,
    y2: 45.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 34.972,
    y1: 1.951,
    x2: 34.972,
    y2: 45.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FBD96"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.61 .977)",
    d: "M0 0h45.366v45.366H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonus);
export default __webpack_public_path__ + "static/media/bonus.4089ae50488ed13de8dfa34655c367ed.svg";
export { ForwardRef as ReactComponent };